<template>
  <sc-page-base
    :title="title"
    :loading="loading">
    <div class="columns">
      <div class="column">
        <sc-analytics-filters
          :loading="masterLoading"
          @form-submit="onFormSubmit"/>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <sc-analytics-summary
          ref="scAnalyticsSummary"
          class="page-recon-analytics__modules" />
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <sc-analytics-monthly-revenue
          ref="scAnalyticsMonthlyRevenue"
          class="page-recon-analytics__modules" />
      </div>
    </div>

    <div class="columns">
      <div class="column is-6">
        <sc-analytics-consolidated-lp
          ref="scAnalyticsConsolidatedLp"
          class="page-recon-analytics__modules" />
      </div>

      <div class="column is-6">
        <sc-analytics-status-recon
          ref="scAnalyticsStatusRecon"
          class="page-recon-analytics__modules" />
      </div>
    </div>

    <div class="columns">
      <div class="column is-6">
        <sc-analytics-status-waiting-avaliation
          ref="scAnalyticsWaitingAvaliation"
          class="page-recon-analytics__modules" />
      </div>

      <div class="column is-6">
        <sc-analytics-status-release-payment
          ref="scAnalyticsReleasePayment"
          class="page-recon-analytics__modules" />
      </div>
    </div>
  </sc-page-base>
</template>

<script>
import { ScPageBase } from '@intelipost-js/secure-components';
import { createNamespacedHelpers } from 'vuex';

import ScAnalyticsFilters from './components/analytics-filters/ScAnalyticsFilters';
import ScAnalyticsConsolidatedLp from './components/analytics-consolidated-lp/ScAnalyticsConsolidatedLp';
import ScAnalyticsMonthlyRevenue from './components/analytics-monthly-revenue/ScAnalyticsMonthlyRevenue';
import ScAnalyticsStatusRecon from './components/analytics-status-recon/ScAnalyticsStatusRecon';
import ScAnalyticsStatusReleasePayment from './components/analytics-status-release-payment/ScAnalyticsStatusReleasePayment';
import ScAnalyticsStatusWaitingAvaliation from './components/analytics-status-waiting-avaliation/ScAnalyticsStatusWaitingAvaliation';
import ScAnalyticsSummary from './components/analytics-summary/ScAnalyticsSummary';

const { mapState } = createNamespacedHelpers('recon/analytics');

export default {
  name: 'page-analytic',
  data() {
    return {
      title: 'Relatórios',
      loadData: false,
    };
  },
  computed: {
    ...mapState([
      'loading',
    ]),
    masterLoading() {
      const analyticsStates = this.$store.state.recon.analytics;

      const loadingList = Object.keys(analyticsStates)
        .map(key => analyticsStates[key] && analyticsStates[key].loading)
        .filter(item => item);

      return loadingList.length > 0;
    },
  },
  methods: {
    onFormSubmit(form = {}) {
      Object.keys(this.$refs).forEach((key) => {
        if (this.$refs[key].loadData && typeof this.$refs[key].loadData === 'function') {
          this.$refs[key].loadData(form);
        }
      });
    },
  },
  components: {
    ScPageBase,
    ScAnalyticsFilters,
    ScAnalyticsConsolidatedLp,
    ScAnalyticsMonthlyRevenue,
    ScAnalyticsStatusRecon,
    ScAnalyticsStatusReleasePayment,
    ScAnalyticsStatusWaitingAvaliation,
    ScAnalyticsSummary,
  },
};
</script>

<style lang="scss">
.page-recon-analytics__modules {
  position: relative;

  .page-loading__inside {
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/analytics/PageAnalytics.vue?1fe61722